(function($) {

	$.fn.fixedSticky = function() {
        var elem = $(this);

        var init = function() {
        	//elem.fixedsticky();
        };

        init();
        return this;
	};

}($));